export default __webpack_public_path__ + "static/media/network.0bc33bfc.jpg";